/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProductCardModelSpecificationGroupSearchProductResponse,
  SearchRequestModel,
  ValidationErrorResponse,
} from '../models/index';
import {
    ProductCardModelSpecificationGroupSearchProductResponseFromJSON,
    ProductCardModelSpecificationGroupSearchProductResponseToJSON,
    SearchRequestModelFromJSON,
    SearchRequestModelToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models/index';
import { HandleRequest } from '../../handle-request'
export type SearchRequest = {
    catalog: string;
    searchRequestModel?: SearchRequestModel;
}



/**
 * 
 */
export class SearchApi extends runtime.BaseAPI {


    /**
     */
     search = HandleRequest.Handle<SearchRequest,ProductCardModelSpecificationGroupSearchProductResponse>('SearchApi_search',async (requestParameters: SearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductCardModelSpecificationGroupSearchProductResponse>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling search().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/search`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRequestModelToJSON(requestParameters['searchRequestModel']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductCardModelSpecificationGroupSearchProductResponseFromJSON(jsonValue));
    })

    /**
     */


}
